import { render } from "./vk.svg?vue&type=template&id=86c243dc"
const script = {}
script.render = render

export default script